export interface IFilterValue {
	value: string;
	name: string | number;
	filterSelectName?: string;
	selected: boolean;
}

export interface IImage {
	uri: string;
	alt: string;
	id: string;
}

export interface ISelectedFilterValue extends IFilterValue {
	filterName: string;
}

export interface IFilter<ValueType = any> {
	open: boolean;
	values: ValueType[] 
}

export interface ITagsFilter extends IFilter<IFilterValue> {
}

export interface IDateFilterValue {
	year: number;
	months: IFilterValue[];
}

export interface IDatesFilter extends IFilter<IDateFilterValue> {
}

export interface IPost {
	id: string;
	title: string;
	ingress: string;
	uri: string;
	date: string;
	dateLong: number;
	tags: string[];
	images: IImage[];
}

export interface IPagination {
	current: number;
	max: number;
}

export interface IState {
	filters: {
		[key: string]: ITagsFilter | IDatesFilter | IFilter;
		tags: ITagsFilter;
		dates: IDatesFilter;
	};
	posts: IPost[];
	pagination: IPagination;
	total: number;
	isEditMode: boolean;
	isFetching: boolean;
	searchUrl: string;
	rssUrl: string;
	subscribeUrl: string;
	selectedFilterValues: ISelectedFilterValue[];
	noHits: string;
}

const deafultState: IState = {
	searchUrl: '',
	rssUrl: '',
	subscribeUrl: '',
	noHits: '',
	selectedFilterValues: [],
	isEditMode: false,
	isFetching: false,
	filters: {
		dates: {
			open: false,
			values: []
		},
		tags: {
			open: false,
			values: []
		}
	},
	total: 0,
	pagination: {
		current: 0,
		max: 0	
	},
	posts: []
};

export default deafultState;
